import { apiGet } from "./AGIAPI";

export async function getConfiguration() {
    return await apiGet(`configuration`);
}
